import { IconBookmark, IconBuildings, IconCoil, IconEnergyCircle, IconRuler, IconShare, IconSignal, IconTools } from '@assets/images/icon';
import { bell1 } from '@assets/images/main/iot/product';
import { airQuality1, coMeasure1, sensorThumb } from '@assets/images/main/sensor';

export default {
  a: [
    { text: '主な用途', icon: IconCoil },
    { text: '測定項目', icon: IconRuler },
    { text: '通信帯域', icon: IconSignal },
    { text: '設置環境', icon: IconEnergyCircle },
    { text: '電源方式', icon: IconTools },
    { text: '特徴の要約', icon: IconBuildings },
    { text: 'ORBRO連携の有無', icon: IconBookmark },
    { text: '外部連携', icon: IconShare },
  ],

  b: [
    { text: '工場設備の状態検知' },
    { text: '温度、湿度、水漏れ、圧力、振動、接点など' },
    { text: 'LoRa、RS-485' },
    { text: '建設現場、プラント、物流倉庫など' },
    { text: 'バッテリー / DC電源' },
    { text: '多様なセンサー入力に対応、6kmのLoRa無線通信対応' },
    { text: '対応済み' },
    { text: 'API提供' },
  ],

  c: [
    { text: 'CO₂漏れの検知および警告' },
    { text: '一酸化炭素、温度' },
    { text: 'Wi-Fi、RS-485' },
    { text: '密閉空間、下水処理場、廃棄物施設など' },
    { text: 'バッテリー / DC電源' },
    { text: '有害環境向けのCO₂専用センサー、感度と危険性の高い場所に最適' },
    { text: '対応済み' },
    { text: 'API提供' },
  ],

  d: [
    { text: '屋内の空気品質モニタリング' },
    { text: 'PM、CO₂、TVOC、温湿度' },
    { text: 'Wi-Fi、RS-485' },
    { text: '病院、オフィス、公共施設などの屋内環境' },
    { text: 'DC 24V' },
    { text: '高精度な空気品質分析、環境省認証取得済み' },
    { text: '対応済み' },
    { text: 'API提供' },
  ],

  e: [
    { text: '緊急時のアラート通知' },
    { text: '非常ボタンの状態' },
    { text: 'Bluetooth 5、Wi-Fi' },
    { text: '病院、倉庫、オフィス、現場通路など' },
    { text: 'AAAバッテリー' },
    { text: 'メッセージ送信、Wi-Fi連携、低電力動作' },
    { text: '対応済み' },
    { text: 'API提供' },
  ],

  spec: [
    {},

    {
      image: sensorThumb,
      link: '/jp/iot/LoRASensor',
      title: 'LoRaセンサー',
      desc: 'New',
    },
    {
      image: coMeasure1,
      link: '/jp/iot/co2',
      title: 'CO₂測定器',
      desc: 'New',
    },
    {
      image: airQuality1,
      link: '/jp/iot/air',
      title: '空気品質モニター',
      desc: 'New',
    },
    {
      image: bell1,
      link: '/jp/iot/bell',
      title: '非常ベル',
      desc: '',
    },
  ],
};
